"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountDialog = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const mui_inputs_core_1 = require("@dzambalaorg/mui-inputs-core");
const AccountDialog = () => {
    return (0, jsx_runtime_1.jsx)(mui_inputs_core_1.TextInput, { name: "account", required: true });
};
exports.AccountDialog = AccountDialog;
//# sourceMappingURL=index.js.map